import { useDispatch } from "react-redux";
import { Button } from "../../shared/button/button";
import { ContainerMenuStyled } from "./styles";
import { logout } from "../../redux/actions/user.actions";
import { NormalText } from "../../shared/styles";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";

export const DropdownProfile = ({ user, isLoadingUser, handleClose }) => {
  const menuRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleLogOut() {
    if (user?.usuario) {
      dispatch(logout(user?.usuario, user?.clave));
    }
    // Igual que en user.actions.js: la clave real es "tokenContraPago".
    localStorage.removeItem("tokenContraPago");
    localStorage.removeItem("userId");
    window.location.href = "/";
    handleClose && handleClose();
  }

  function handleGoToProfile() {
    navigate("/profile");
    handleClose && handleClose();
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleClose && handleClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClose]);

  return (
    <ContainerMenuStyled ref={menuRef}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={"8px"}
        borderBottom={"1px solid #D4D4D4"}
        padding={"16px"}
      >
        <NormalText>{user?.email}</NormalText>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        width={"100%"}
        alignItems={"center"}
        pb={"16px"}
      >
        <Button
          label={"Profile"}
          type={"regular"}
          onClick={handleGoToProfile}
          isLoading={isLoadingUser}
          containerStyles={{
            width: "100%",
          }}
          buttonStyles={{
            width: "100%",
            padding: "8px !important",
          }}
        />
        <Button
          label={"Log out"}
          type={"regular"}
          onClick={handleLogOut}
          isLoading={isLoadingUser}
          containerStyles={{
            width: "100%",
          }}
          buttonStyles={{
            width: "100%",
            padding: "8px !important",
          }}
        />
      </Box>
    </ContainerMenuStyled>
  );
};
